<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 42" role="graphics-symbol">
    <g fill="currentColor">
      <path
        d="M12.5 41.8c1.5 0 2.9-.1 4.2-.4v-.8c-1.3-.3-2.7-.4-4.2-.4s-2.9.1-4.2.4v.8c1.3.3 2.8.4 4.2.4M22.7 17.4c-1.2-2.7-2.9-5.2-3.2-8.2-.2-2.6.9-3.8 2.7-4.3V3.4H20c-1.3 1.4-1.8 2.9-2 4.8-.5 6.3 4.6 11.4 3.8 17.7-.5 3.7-4.4 5.2-8.7 5.5V0h-1.3v31.4c-4.3-.3-8.3-1.7-8.7-5.5C2.3 19.6 7.4 14.5 7 8.2c-.2-1.8-.7-3.4-2-4.8H2.7v1.5c1.8.5 2.9 1.7 2.7 4.3-.3 2.9-1.9 5.4-3.2 8.2s-2.4 6-2.2 9.2c.4 6.2 5.4 8.2 11.8 8.6v2.3h1.3v-2.3c6.4-.4 11.4-2.5 11.8-8.6.3-3.2-.9-6.4-2.2-9.2"
      />
      <path d="M9 3.4h1.3v24.8H9zM14.7 3.4H16v24.8h-1.3z" />
    </g>
  </svg>
</template>
